// @ts-check

/**
 * @typedef {object} TelegramBotNameConfig
 * @property {string | null} prod
 * @property {string | null} dev
 */

/** @type {Record<import('./brand-by-target.mjs').Brand, TelegramBotNameConfig>} */
export const TELEGRAM_BOT_NAME_CONFIG = {
  lm: {
    prod: process.env.NEXT_PUBLIC_TELEGRAM_BOT_NAME_MILLION_PROD,
    dev: process.env.NEXT_PUBLIC_TELEGRAM_BOT_NAME_MILLION_DEV,
  },
  pw: {
    prod: process.env.NEXT_PUBLIC_TELEGRAM_BOT_NAME_PINGWINCASINO_PROD,
    dev: process.env.NEXT_PUBLIC_TELEGRAM_BOT_NAME_PINGWINCASINO_DEV,
  },
  ph: {
    prod: process.env.NEXT_PUBLIC_TELEGRAM_BOT_NAME_POWERPLAY_PROD,
    dev: null,
  },
  ph2: {
    prod: null,
    dev: null,
  },
};
